import { getIdSet } from './getIdSet';
import { difference, flatMap, flatten, union } from 'lodash';

interface SelectAllCriteria {
  /* The endpoint to get select all from */
  endpoint: string;
  /* Filters to include in the request */
  filters?: object;
  /* Query to include in the request */
  query?: object;
  /* *true* if selecting all, *false* if deselecting */
  isChecked: boolean;
  /* The total count of data */
  totalCount: number;
  /* The previously selected items IDs */
  selectedIds: Array<number | string>;
  /* Data entity (used to request only IDs) */
  entity: string;
  /* Sort field (used to make sure requests don't duplicate results) */
  sortValue?: string;
  /* Authentication token (needed for some endpoints) */
  authToken?: string;
  /* *true* if want to filter out deactivated records */
  skipInactive?: boolean;
}

/**
 * Allows selecting all records for paginated results
 */
export const selectAll = async ({
  endpoint,
  filters,
  query,
  isChecked,
  totalCount,
  selectedIds,
  entity,
  sortValue,
  authToken,
  skipInactive = false,
}: SelectAllCriteria) => {
  const pageSize = 1000;
  const numberOfRequests = Math.ceil(totalCount / pageSize);

  const functionArray: unknown[] = [];
  for (let count = 0; count < numberOfRequests; count++) {
    functionArray.push(getIdSet);
  }

  try {
    const values = await Promise.all(
      functionArray.map((func, index) => {
        const extraFields = skipInactive ? 'active' : null;
        // @ts-ignore
        return func({ endpoint, filters, page: index + 1, pageSize, query, entity, sortValue, authToken, extraFields });
      })
    );

    const flattened = flatMap(values, f => f.data);
    const filtered = skipInactive ? flattened.filter(item => !!item.attributes && item.attributes.active) : flattened;
    const skipped =
      skipInactive && isChecked
        ? flattened.filter(item => !!item.attributes && !item.attributes.active).map(item => item.id)
        : [];
    const newArray = filtered.map(item => item.id);

    let selected = [];
    if (isChecked) {
      // selecting all
      // @ts-ignore
      selected = flatten(union([selectedIds, newArray]));
    } else {
      // deselecting all
      // @ts-ignore
      selected = difference(selectedIds, newArray);
    }

    return skipInactive ? { selected, skipped } : selected;
  } catch (err) {
    return [];
  }
};
